import {
  ChangeEVSEStatusRequest,
  CreateEVSERequest,
  UpdateEVSEMetadataRequest,
} from './requests/evse-request.ts';
import { apiClient } from './client.tsx';
import {
  ChangeEVSEStatusResponse,
  CreateEVSEResponse,
  GetEVSEResponse,
  UpdateEVSEMetadataResponse,
} from './responses/evse-response.ts';

export const createEVSE = (request: CreateEVSERequest) =>
  apiClient
    .post<CreateEVSEResponse>(`/v2/evses`, request)
    .then((res) => res.data.data);

export const updateEVSEMetadata = (request: UpdateEVSEMetadataRequest) =>
  apiClient
    .put<UpdateEVSEMetadataResponse>(`/v2/evses/${request.evseId}`, request)
    .then((res) => res.data.data);

export const getEVSE = (evseId: string) =>
  apiClient
    .get<GetEVSEResponse>(`/v2/evses/${evseId}`)
    .then((res) => res.data.data);

export const changeEVSEStatus = (request: ChangeEVSEStatusRequest) =>
  apiClient
    .post<ChangeEVSEStatusResponse>(
      `/v2/evses/${request.evseId}/status`,
      request,
    )
    .then((res) => res.data.data);

export const removeEVSE = (evseId: string) =>
  apiClient.delete(`/v2/evses/${evseId}`);
